import { useSelector } from 'react-redux'
import { editorSelectors } from 'store/features/editor/selectors'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import GenerationHistory from './GenerationHistory'
import VersionHistory from './VersionHistory'

interface IHistoryTabProps {
  // `sidebar` = rendered in the AIVideoContent tab (near-flush wrapper);
  // `overlay` = rendered inside the Smart Edit overlay's padded Content.
  variant?: 'sidebar' | 'overlay'
}

const HistoryTab = ({ variant = 'overlay' }: IHistoryTabProps) => {
  const activeTimelineItemId = useSelector(editorSelectors.activeTimelineItemId)
  const showVersionHistoryTab = useSelector(
    aiVideoSelectors.showVersionHistoryTab
  )
  const hasSelectedItem = !!activeTimelineItemId

  return hasSelectedItem || showVersionHistoryTab ? (
    <VersionHistory variant={variant} />
  ) : (
    <GenerationHistory />
  )
}

export default HistoryTab
